<template>
    <div>
        <div class="keyWord-box">
            <div class="lft-key-box">
                <div style="display:flex;">
                    <div :class="keyText=='7'?'key-btn key-btn-active':'key-btn'" @touchstart="downButton('7')" @touchend="upButton()" id="7">7</div>
                    <div :class="keyText=='8'?'key-btn key-btn-active':'key-btn'" @touchstart="downButton('8')" @touchend="upButton()" id="8">8</div>
                    <div :class="keyText=='9'?'key-btn key-btn-active':'key-btn'" @touchstart="downButton('9')" @touchend="upButton()" data-key="9">9</div>
                </div>
                <div style="display:flex">
                    <div :class="keyText=='4'?'key-btn key-btn-active':'key-btn'" @touchstart="downButton('4')" @touchend="upButton()" bindtap="clickKey" data-key="4">4</div>
                    <div :class="keyText=='5'?'key-btn key-btn-active':'key-btn'" @touchstart="downButton('5')" @touchend="upButton()" bindtap="clickKey" data-key="5">5</div>
                    <div :class="keyText=='6'?'key-btn key-btn-active':'key-btn'" @touchstart="downButton('6')" @touchend="upButton()" bindtap="clickKey" data-key="6">6</div>
                </div>
                <div style="display:flex">
                    <div :class="keyText=='1'?'key-btn key-btn-active':'key-btn'" @touchstart="downButton('1')" @touchend="upButton()" bindtap="clickKey" data-key="1">1</div>
                    <div :class="keyText=='2'?'key-btn key-btn-active':'key-btn'" @touchstart="downButton('2')" @touchend="upButton()" bindtap="clickKey" data-key="2">2</div>
                    <div :class="keyText=='3'?'key-btn key-btn-active':'key-btn'" @touchstart="downButton('3')" @touchend="upButton()" bindtap="clickKey" data-key="3">3</div>
                </div>
                <div style="display:flex">
                    <div :class="keyText=='0'?'key-btn key-btn-active':'key-btn'" @touchstart="downButton('0')" @touchend="upButton()" style="flex:2" bindtap="clickKey" data-key="0">0</div>
                    <div :class="keyText=='.'?'key-btn key-btn-active':'key-btn'" @touchstart="downButton('.')" @touchend="upButton()" style="flex:1" bindtap="clickKey" data-key=".">.</div>
                </div>
            </div>
            <div class="rgt-key-box">
                <div :class="keyText=='clear'?'key-btn-primary key-btn-primary-active':'key-btn-primary'" @touchstart="downButton('clear')" @touchend="upButton()" bindtap="clickKey" data-key="clear">Clear</div>
                <div :class="keyText=='del'?'key-btn-primary key-btn-primary-active':'key-btn-primary'" @touchstart="downButton('del')" @touchend="upButton()" bindtap="clickKey" data-key="del">
                    <div class="icon icontuigex" style="color:#fff"></div>
                </div>
                <div :class="keyText=='enter'?'key-btn-primary enter-key key-btn-primary-active':'key-btn-primary enter-key'" @touchstart="downButton('enter')" @touchend="upButton()" bindtap="clickKey">
                    <div class="icon iconhuiche"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'QianweiApputilsFrontendIndex',
    props:['value'],
    data() {
        return {
            goodModel:{
                num:20
            },
            type:'MERCHANT',
            keyText:'',
            focusKey:'num',
            focusValue:10,
        };
    },
    mounted() {
    },
    beforeDestroy(){
        document.onmousedown = null
    },
    methods: {
        downButton(res){
            this.keyText = res
        },
        upButton(){
            if(this.focusKey){
                let key = JSON.parse(JSON.stringify(this.keyText))
                let value = JSON.parse(JSON.stringify(this.value))
                this.keyText = ''
                if (key == 'enter') {
                    value = 'enter'
                } else if (key == 'clear') {
                    value = ''
                } else if (key == 'del') {
                    let spliceValue = String(value).slice(0, value.length - 1)
                    value = spliceValue
                } else {
                    if(key == '.' && value.split('.').length>=2){
                        return
                    }else{
                        if(value == 0 || value == '0' && value!='0.' && key != '.'){
                            value = key
                        }else if(!value && key == '.'){
                            value = '0'+key
                        }else{
                            value = value + key
                        }
                            // value = value == 0 && key !='.' ? key : value + key
                    }
                }
                this.$emit('change', value);
            }else{
                let key = res.currentTarget.dataset.key
                let value=''
                if (key == 'enter') {
                    value = 'enter'
                }
                this.$emit('change', value);
            }
        },
    },
};
</script>

<style scoped>
    .keyWord-box{
        margin:10px 15px;
        display:flex
    }
    .key-btn{
        border: 0px;
        width:100%;
        height:50px;
        font-size:15px;
        font-weight:700;
        background:#ddd;
        color:#555;
        text-align:center;
        line-height:50px;
        margin:2px; 
        border-radius: 5px;
    }
    .key-btn-active{
        background: #f2f2f2;
    }
    .key-btn-primary{
        border: 0px;
        width:100%;
        height:50px;
        font-size:15px;
        font-weight:700;
        text-align:center;
        line-height:50px;
        margin:2px; 
        border-radius: 5px;
        background: #486ad8;
        color:#fff;
    }
    .key-btn-primary .icon{
        font-size:20px
    }
    .key-btn-primary-active{
        background: #738fea;
        color:#fff;
    }
    .lft-key-box{
        width: calc(100% - 110px);
    }
    .rgt-key-box{
        width:110px;
        display:flex;
        flex-direction:column
    }
    .enter-key{
        height:102px;
        line-height:102px;
    }
    .enter-key .icon{
        color:#fff;
        font-size:16px;
        font-weight:500
    }
</style>


// WEBPACK FOOTER //
// src/components/QWKeyWord/index.vue